import {
  placeholderTenant,
  SelectedTenantContext
} from "polyrouter/SelectedTenantProvider";
import { needs, useGuard } from "rbac";
import React, { useContext } from "react";
import { MemberRoleNames } from "roles";
import { tenantTypeToTagsMap } from "routes/Admin/Accounts/Members/Helpers";
import UserTable from "routes/Admin/Accounts/Members/UserTable";
import { LocalKeys } from "utilities/i18n";

export const labels = {
  userColumnHeader: "MEMBER_NAME" as LocalKeys,
  deleteDialogTitle: "DELETE_ACCOUNT_MEMBER" as LocalKeys,
  deleteDialogContent: "CONFIRM_DELETE_MEMBERS" as LocalKeys,
  deleteDialogConfirm: "DELETE_ACCOUNT_MEMBER" as LocalKeys,
  deleteDialogSuccess: "SUCCESSFULLY_DELETED_USERS" as LocalKeys
};
const MembersTableView: React.FC = () => {
  const tenant = useContext(SelectedTenantContext).tenant ?? placeholderTenant;
  const tags = tenantTypeToTagsMap[tenant.type];
  const memberCanEdit = useGuard(needs("grant:role"));

  return (
    <UserTable
      tenant={tenant}
      roles={MemberRoleNames}
      tags={tags}
      editingAllowed={memberCanEdit}
      labels={labels}
    />
  );
};

export default MembersTableView;
